import { SectionError } from "~/components/company/section-error";
import { ContractsTab, fetchContracts } from "~/components/company/tabs/contracts-tab";
import {
	companyCanonicalUrl,
	companyFromMatches,
	companyNotFoundMeta,
	companySocialMeta,
	parseIcoSlug,
} from "~/lib/company-profile";
import { generateMetaTags } from "~/lib/seo";
import type { Route } from "./+types/smlouvy";

export async function loader({ params }: Route.LoaderArgs) {
	const ico = parseIcoSlug(params.icoSlug);

	// Degrade to an in-tab error state on failure — a section endpoint error
	// must not take down the whole profile page.
	const contracts = await fetchContracts(ico, 1, "all").catch(() => null);
	return { ico, contracts };
}

export function meta({ data: loaderData, matches }: Route.MetaArgs) {
	const company = companyFromMatches(matches);
	if (!company) return companyNotFoundMeta();

	return generateMetaTags({
		...companySocialMeta(company),
		title: `Smlouvy v registru – ${company.name} | FirmIndex`,
		description: `Smlouvy firmy ${company.name} (IČO: ${company.ico}) z registru smluv — hodnoty, data uzavření a smluvní strany.`,
		canonical: companyCanonicalUrl(company, "smlouvy"),
		noindex: !loaderData?.contracts || loaderData.contracts.total === 0,
	});
}

export default function CompanySmlouvyRoute({ loaderData }: Route.ComponentProps) {
	if (!loaderData.contracts) {
		return <SectionError message="Nepodařilo se načíst smlouvy." />;
	}
	return <ContractsTab ico={loaderData.ico} initialData={loaderData.contracts} />;
}
